<template>
  <div
    class="mainheader"
    :class="{ background: $route.path == '/', headerbg: $route.path != '/' }"
  >
    <TopHeader  :class="{ top_header_section: $route.path != '/' }" />
    <TopHeaderNavbar :class="{ topHeaderNavbarMenu: $route.path != '/' }" />
    <div class="headercontet" v-if="$route.path == '/'">
      <HeaderContent />
    </div>
  </div>
</template>

<script>
import TopHeader from "./TopHeader.vue";
import TopHeaderNavbar from "./TopHeaderNavbar.vue";
import HeaderContent from "./HeaderContent.vue";
export default {
  data() {
    return {};
  },
  props:{
    data:Object
  },
  components: { TopHeader, TopHeaderNavbar, HeaderContent },
};
</script>

<style>
.background {
  width: 100%;
  height: 100vh;
  background-image: url(../../assets/images/banner_image.jpeg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: multiply;
}

.headerbg {
  background-color: darkgray;
}

.top_header_section {
  background-color: #eee;
}

.top_header_section .phone span {
  color: black;
}
.top_header_section .panel {
  color: #000;
}

.top_header_section .Lang__Change {
  color: #000;
}

.top_header_section .earthIcon path {
  fill: #000;
}

.top_header_section .earthIcon path {
  fill: #000;
}

.top_header_section .phoneIcon path,
.useriIcon path {
  fill: #000;
}


</style>


<style>
.top_header_section .social__logo path {
  fill: #000;
}

.topHeaderNavbarMenu {
  background-color: #fff !important;
}

.topHeaderNavbarMenu .navbar__menu__list a {
  color: #000;
}
</style>